module.exports = __webpack_public_path__ + "fonts/UcCo3FwrK3iLTcviYwYZ8UA3.7d00648.woff2";